import { Intent } from "@blueprintjs/core";
import { ToolTipButton } from "nsitools-react";
import * as React from "react";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface ISharepointFileButtonProps extends ICustomButtonProps {
  text: string;
  tooltip?: ETLCodes;
}

export const SharepointFileButton: React.FunctionComponent<ISharepointFileButtonProps> = ({
  minimal = true,
  loading,
  disabled,
  text,
  intent = Intent.PRIMARY,
  tooltip = ETLCodes.DownloadDocument,
  onClick,
}) => {
  const { t } = useTl();
  return (
    <ToolTipButton
      tooltip={t(tooltip)}
      intent={intent}
      disabled={disabled}
      minimal={minimal}
      loading={loading}
      onClick={onClick}
      text={text}
    />
  );
};
